export const MathUtils = {
    // map number x from range [a, b] to [c, d]
    map: (x, a, b, c, d) => ((x - a) * (d - c)) / (b - a) + c,
    // linear interpolation
    lerp: (a, b, n) => (1 - n) * a + n * b
};

export const DeviceUtils = {
    isMobileDevice: () => {
        return typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1;
    }
};

export const DomUtils = {
    elementPresent: (element) => {
        const style = getComputedStyle(element);
        const display = style.display;
        return display !== 'none';
    },
    getViewportWidth: () => {
        return document.documentElement.clientWidth;
    },
    getViewportHeight: () => {
        return document.documentElement.clientHeight;
    }
};

export const CookieUtils = {
    setCookie: (cookieName, cookieValue, numberOfHoursValid) => {
        const date = new Date();
        date.setTime(date.getTime() + numberOfHoursValid * 60 * 60 * 1000);
        const expiresOn = 'expires=' + date.toUTCString();
        document.cookie = cookieName + '=' + cookieValue + ';' + expiresOn + ';path=/';
    },
    getCookie: (cookieName) => {
        const name = cookieName + '=';
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    }
};

// Linear interpolation
export const lerp = (a, b, n) => (1 - n) * a + n * b;

// Gets the mouse position
export const getMousePos = (e) => {
    return {
        x: e.clientX,
        y: e.clientY
    };
};

export const distance = (x1, y1, x2, y2) => {
    var a = x1 - x2;
    var b = y1 - y2;

    return Math.hypot(a, b);
};
